import React from "react";
import { useSelector, useDispatch } from "react-redux";

import ModeSelect from "./ModeSelect/ModeSelect";
import ToolbarMenu from "./ToolbarMenu/ToolbarMenu";
import ToolbarLogo from "./ToolbarLogo/ToolbarLogo";
import ToolbarModal from "./ToolbarModal/ToolbarModal";
import { Container, Spacer } from "./ToolbarStyles";
import {
  SwitchContainer,
  Option,
} from "../HeatMap/HeatMapControl/HeatMapFilters/FilterSwitches/FilterSwitchesStyles";
import { setSelectedHeatmapView } from "../../redux/slices/heatMap";

export default function Toolbar() {
  const dispatch = useDispatch();
  const {display, isInitialLoad} = useSelector(({ display }) => display);
  const heatmapView = useSelector(({ heatMap }) => heatMap.selectedView)

  return (
    <Container>
      <ToolbarModal />
      <ToolbarLogo />
      <Spacer />
      <ModeSelect />
      <Spacer />
      {isInitialLoad===false && display === "heatMap" && (
        <SwitchContainer side={"left"}>
          <Option
            side={"left"}
            selected={heatmapView === "heatmap"}
            onClick={() => {dispatch(setSelectedHeatmapView("heatmap"))}}
            selectedColor={"#87CEFA"}
          >
            <p>Heat Map</p>
          </Option>
          <Option
            side={"right"}
            selected={heatmapView === "table"}
            onClick={() => {dispatch(setSelectedHeatmapView("table"))}}
            selectedColor={"#FFA500"}
          >
            <p>Table</p>
          </Option>
        </SwitchContainer>
      )}
      <ToolbarMenu />
    </Container>
  );
}
